export default __webpack_public_path__ + "static/media/Kilner.aa6bf69c.jpg";